import { Grid, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import ReactHookFormSelect from "../ReactHookFormSelect";
import styled from "styled-components";
import DatePickerCM from "../DatePicker";
import { cities_data } from "./provinces_cities";
import { provinces_data } from "./provinces";
import { useEffect } from "react";
import FileUploadInputCm from "../FileUploadInput";
import { StyledGlDateBox } from "styles/globals";

export const StyledMenuItem = styled(MenuItem)`
  text-align: right !important;
  direction: rtl;
`;

function TextFieldCm({
  label,
  id,
  errors,
  type,
  variant,
  control,
  selectItems,
  defaultValue,
  setInputValues,
  defaultProvince,
  defaultCity,
  register,
  fileProps,
  datePickerType,
  shrink,
  rows,
  inpSize
}) {
  const [selectedVal, setSelectedVal] = useState(defaultValue || "");
  const [value] = useState(defaultValue || "");
  const [cities, setCities] = useState("");
  const changeProvincesHandler = (provincesId, city) => {
    setCities(
      cities_data?.data.filter((city) => city.province_id === provincesId)
    );
    setInputValues(`${id}_province`, provincesId);
    setInputValues(`${id}_city`, city || "");
  };

  useEffect(() => {
    if (type === "place") {
      changeProvincesHandler(defaultProvince || "02", defaultCity || "10");
    }
  }, []);

  if (type === "file") {
    return (
      <FileUploadInputCm
        id={id}
        title={label}
        register={register}
        {...fileProps}
      />
    );
  }

  if (type === "place") {
    const provincesId = id + "_province";
    const cityId = id + "_city";
    return (
      <>
        <Grid item lg={4}>
          <ReactHookFormSelect
            label={label || "استان"}
            control={control}
            title={label || "استان"}
            id={provincesId}
            {...register(provincesId)}
            size={inpSize || "medium"}
            error={Boolean(errors?.[provincesId])}
            helperText={errors?.[provincesId]?.message}
            defaultValue={defaultProvince || "02"}
            onChange={(province_id) => changeProvincesHandler(province_id)}
          >
            {provinces_data?.data?.map((item, index) => (
              <StyledMenuItem key={index + item.id} value={item.id}>
                {item.province}
              </StyledMenuItem>
            ))}
          </ReactHookFormSelect>
        </Grid>
        <Grid item lg={4}>
          <ReactHookFormSelect
            label={label || "شهر"}
            control={control}
            title={label || "شهر"}
            id={cityId}
            size={inpSize || "medium"}
            {...register}
            error={Boolean(errors?.[cityId])}
            helperText={errors?.[cityId]?.message}
            defaultValue={defaultCity || "10"}
            onChange={(city_id) => setInputValues("birth_location", city_id)}
          >
            {!cities.length ? (
              <StyledMenuItem disabled value={"not selected provinces"}>
                اول استان باید انتخاب شود
              </StyledMenuItem>
            ) : (
              cities?.map((item, index) => (
                <StyledMenuItem key={index + item.city_id} value={item.city_id}>
                  {item.city}
                </StyledMenuItem>
              ))
            )}
          </ReactHookFormSelect>
        </Grid>
      </>
    );
  }

  if (type === "date") {
    return (
      <StyledGlDateBox>
        <DatePickerCM
          label={label || "تست"}
          id={id}
          type={datePickerType || "Date"}
          calendarPosition="bottom"
          register={register}
          errors={errors}
        />
      </StyledGlDateBox>
    );
  }

  if (type === "select") {
    return (
      <ReactHookFormSelect
        label={label || "تست"}
        control={control}
        title={label || "تست"}
        id={id}
        size={inpSize || "medium"}
        {...register(id)}
        error={Boolean(errors?.[id])}
        helperText={errors?.[id]?.message}
        defaultValue={selectedVal || ""}
        onChange={(value) => setSelectedVal(value)}
      >
        {!selectItems || !selectItems?.length ? (
          <StyledMenuItem disabled value={"without_options"}>
            هیچ موردی یافت نشد
          </StyledMenuItem>
        ) : (
          selectItems?.map((item, index) => (
            <StyledMenuItem key={"input_item" + index + id} value={item.value}>
              {item.title}
            </StyledMenuItem>
          ))
        )}
      </ReactHookFormSelect>
    );
  }

  return (
    <TextField
      label={label || "تست"}
      variant={variant || "outlined"}
      fullWidth
      id={id}
      defaultValue={value}
      size={inpSize || "medium"}
      type={type || "text"}
      rows={rows || 1}
      multiline={Boolean(rows)}
      {...register(id)}
      error={Boolean(errors?.[id])}
      helperText={errors?.[id]?.message}
      InputLabelProps={{
        shrink: shrink
      }}
    />
  );
}

export default TextFieldCm;
